import { useStore } from "vuex";

function setMetaTag(name, content) {
  if (!content) return;
  let tag = document.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('name', name);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
}

function setPropertyTag(property, content) {
  if (!content) return;
  let tag = document.querySelector(`meta[property="${property}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('property', property);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
}

const SITE_NAME = '四川省内江市教育基金会';

export default {
  beforeEach: async (to, from, next) => {
    const store = useStore();
    if (store.state.menu.menus.length === 0) {
      await store.dispatch("menu/generateRoutes")
      next({ ...to, replace: true })
    } else {
      next()
    }
  },
  afterEach: (to) => {
    const routeTitle = to.meta && to.meta.title ? String(to.meta.title) : '';
    const pageTitle = routeTitle ? `${routeTitle} - ${SITE_NAME}` : SITE_NAME;
    document.title = pageTitle;

    const description = (to.meta && to.meta.description) ? String(to.meta.description) : `${SITE_NAME}官方网站，致力于教育公益，促进教育公平与发展。`;
    setMetaTag('description', description);
    // Basic Open Graph
    setPropertyTag('og:title', pageTitle);
    setPropertyTag('og:site_name', SITE_NAME);
    setPropertyTag('og:description', description);
    setPropertyTag('og:type', 'website');
  }
}
